import { CostCodes as CostCodesModule, Emails as EmailsModule } from 'common';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AllocateFunds from './allocateFunds/AllocateFunds.component';
import { CancelAccount } from './cancelAccount/CancelAccount.component';
import { ChangePassword } from './changePassword/ChangePassword.component';
import ChangePlan from './changePlan/ChangePlan.component';
import { CommPrefs } from './commPrefs/CommPrefs.component';
import ContactInfo from './contactInfo/ContactInfo.component';
import { Labs } from './labs/Labs.component';
import Locations from './locations/Locations.component';
import ManagePaymentWrapper from './payment/ManagePaymentWrapper.component';
import PaymentMethods from './payment/PaymentMethods.component';
import PaymentSettings from './payment/PaymentSettings.component';
import PersonalContactInfo from './personalContactInfo/PersonalContactInfo.component';
import ReferAFriend from './referAFriend/ReferAFriend.component';
import Regions from './regions/Regions.component';
import ShipFromAddress from './shipFromAddress/ShipFromAddress.component';
import Users from './users/Users.component';
import { RoutePath } from './utils/RoutePath';

const { CostCodes } = CostCodesModule;
const { Emails } = EmailsModule;

/**
|-----------------------------------------------------------------------
| 'Panel' vs 'View':
| 'Panel' appendix is used for the components in Layout module which are
| the top-level components in the react-tree. Let's avoid using 'Panel'
| for components that live inside of a -Panel component. For example, t-
| his 'CenterView' component is an component inside 'CenterPanel'.
|-----------------------------------------------------------------------
*/

export function CenterView(props) {
	const { flags } = props;
	return (
		<div className="center-view">
			<Switch>
				{/* per WEBAPPS-25584, contactInfo page should be displayed by default */}
				<Route exact path="/" component={ContactInfo} />
				<Route
					exact
					path={`${RoutePath.allocateFunds}`}
					component={AllocateFunds}
				/>
				<Route
					exact
					path={`${RoutePath.cancelAccount}`}
					component={CancelAccount}
				/>
				<Route
					exact
					path={`${RoutePath.changePassword}`}
					component={ChangePassword}
				/>
				<Route
					exact
					path={`${RoutePath.changePlan}`}
					component={props => <ChangePlan {...props} flags={flags} />}
				/>
				<Route exact path={`${RoutePath.commPrefs}`} component={CommPrefs} />
				<Route exact path={`${RoutePath.costCodes}`} component={CostCodes} />
				<Route
					exact
					path={[
						`${RoutePath.contactInfo}`,
						`${RoutePath.locationContactInfo}`,
					]}
					component={props => (
						<ContactInfo {...props} key={props.location.pathname} />
					)}
				/>
				<Route exact path={`${RoutePath.emails}`} component={Emails} />
				<Route exact path={`${RoutePath.labs}`} component={Labs} />
				<Route exact path={`${RoutePath.locations}`} component={Locations} />
				<Route
					exact
					path={`${RoutePath.referAFriend}`}
					component={ReferAFriend}
				/>
				<Route exact path={`${RoutePath.regions}`} component={Regions} />
				<Route
					exact
					path={[`${RoutePath.users}`, `${RoutePath.locationUsers}`]}
					component={props => (
						<Users {...props} key={props.location.pathname} />
					)}
				/>
				<Route
					exact
					path={`${RoutePath.userContactInfo}`}
					component={PersonalContactInfo}
				/>
				<Route
					exact
					path={`${RoutePath.shipFromAddress}`}
					component={ShipFromAddress}
				/>
				<Route
					exact
					path={[
						`${RoutePath.paymentMethods}`,
						`${RoutePath.locationPaymentMethods}`,
					]}
					component={props => (
						<PaymentMethods {...props} key={props.location.pathname} />
					)}
				/>
				<Route
					exact
					path={[
						`${RoutePath.paymentSettings}`,
						`${RoutePath.locationPaymentSettings}`,
						`${RoutePath.addPaymentSettings}`,
					]}
					component={props => (
						<PaymentSettings {...props} key={props.location.pathname} />
					)}
				/>
				<Route
					exact
					path={`${RoutePath.addPayment}`}
					component={ManagePaymentWrapper}
				/>
			</Switch>
		</div>
	);
}
